import { INITIALIZE_TERMS, INITIALIZE_CHANNEL_DATA, INITIALIZE_LANGUAGES } from './staticDataActions';

export const initialStaticDataState = {
    termsInitializationTime: null,
    terms: [],
    isChannelInitialized: false,
    channel: {},
    languages: []
};

const staticDataReducer = (state = initialStaticDataState, action) => {
    switch (action.type) {
        case INITIALIZE_TERMS: {
            const { terms } = action.payload;
            const termsInitializationTime = Date.now();
            return {
                ...state,
                terms,
                termsInitializationTime
            };
        }
        case INITIALIZE_CHANNEL_DATA: {
            const { channel } = action.payload;
            return {
                ...state,
                isChannelInitialized: true,
                channel
            };
        }
        case INITIALIZE_LANGUAGES: {
            const { languages } = action.payload;
            return {
                ...state,
                isChannelInitialized: true,
                languages
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default staticDataReducer;
